import {
  $getRoot,
  $isLineBreakNode,
  $isParagraphNode,
  $isTextNode,
  COMMAND_PRIORITY_NORMAL,
  LexicalEditor,
  PASTE_COMMAND
} from "lexical";
import { useEffect } from "react";

export function ClipboardPastePlugin({ editor }: { editor: LexicalEditor }) {
  const handlePostPasteAction = () => {
    const root = $getRoot();
    const children = root.getChildren();

    children.forEach((child) => {
      // Remove empty paragraphs that may have been created during paste
      if ($isParagraphNode(child)) {
        const childNodes = child.getChildren();

        const filteredChildNodes = childNodes.filter((node) => !($isLineBreakNode(node)));

        const hasOnlyEmptyNodes = filteredChildNodes.length === 0;
        const areAllEmptyNodes = filteredChildNodes.every((node) => $isTextNode(node) && node.getTextContent().trim() === '');

        if (
          hasOnlyEmptyNodes
          ||
          areAllEmptyNodes
        ) {
          // console.debug("Removing paragraph node", {
          //   child,
          //   childNodes,
          // });

          child.remove();
        }
      }
    });
  };

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      () => {
        setTimeout(() => {
          editor.update(() => {
            handlePostPasteAction();
          });
        });

        /**
         * false means we don't want to prevent the default paste behavior, 
         * we just want to run our code after the paste has been processed
        */
        return false;
      },
      COMMAND_PRIORITY_NORMAL,
    );
  }, [editor]);

  return null;
}
